import { ComponentRenderHooks } from "@launchos/plugins/types";
import Video from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Video") {
    return [Video];
  }
};
